import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { Link as RouterLink } from 'react-router-dom';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { Copyrights } from '@mwp/frontend-components';

const StyledForgottenPasswordView = styled.div`
  display: flex;
  height: 100vh;

  .image {
    background-image: url(https://source.unsplash.com/random?collection=353844/work);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
  .paper {
    margin: ${({ theme }) => theme.spacing(8, 4)};
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .avatar {
    margin: ${({ theme }) => theme.spacing(1, 1)};
    background-color: ${({ theme }) => theme.palette.secondary.main};
  }
  .form {
    width: 100%;
    margin-top: ${({ theme }) => theme.spacing(1, 1)};
  }
  .submit {
    margin: ${({ theme }) => theme.spacing(3, 0, 2)};
  }
`;

const ForgottenPasswordView = ({
  validationError, onSubmit, onAlertClose,
}) => {
  const { email: emailErr } = validationError;

  const [email, setEmail] = useState('');

  function handleSubmit(event) {
    event.preventDefault();
    onSubmit(email);
  }

  return (
    <StyledForgottenPasswordView>
      <Grid item xs={false} sm={4} md={7} className="image" />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className="paper">
          <Avatar className="avatar">
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Forgotten password
          </Typography>
          <form className="form" noValidate onSubmit={handleSubmit}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              helperText={emailErr}
              error={!!emailErr}
              onChange={(e) => setEmail(e.target.value)}
              value={email}
              autoFocus
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className="submit"
              disabled={!email}
            >
              Send password reset
            </Button>
            <Grid container>
              <Grid item>
                <Link component={RouterLink} to="/login" variant="body2">
                  Already have an account? Sign In
                </Link>
              </Grid>
            </Grid>
            <Box mt={5}>
              <Copyrights />
            </Box>
          </form>
        </div>
      </Grid>
      <Snackbar
        open={!!validationError.other}
        autoHideDuration={6000}
        onClose={onAlertClose}
      >
        <Alert
          severity="error"
          elevation={6}
          variant="filled"
          onClose={onAlertClose}
        >
          {validationError.other}
        </Alert>
      </Snackbar>
    </StyledForgottenPasswordView>
  );
};

ForgottenPasswordView.displayName = 'ForgottenPasswordView';

ForgottenPasswordView.propTypes = {
  validationError: PropTypes.shape({
    email: PropTypes.string,
    password: PropTypes.string,
    other: PropTypes.string,
  }),
  onSubmit: PropTypes.func.isRequired,
  onAlertClose: PropTypes.func.isRequired,
};

ForgottenPasswordView.defaultProps = {
  validationError: {},
};

export default ForgottenPasswordView;
